var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CookieConsent',_vm._b({attrs:{"domain":_vm.domain}},'CookieConsent',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }